<template>
  <div id="app">
    <h4 class="bg-primary text-white text-center p-2">Herramientas IP</h4>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item active">
            <router-link to="/ipclass/generate" class="nav-link">Generar Dir. IP con clase</router-link>
          </li>
          <li class="nav-item active">
            <router-link to="/ipclass/solve" class="nav-link">Resolver Dir Dir. IP con clase</router-link>
          </li>
          <li class="nav-item active">
            <router-link to="/ipcidr/both" class="nav-link">Ejercicio Dir. IP CIDR</router-link>
          </li>
          <li class="nav-item active">
            <router-link to="/subnetting/simmetrical" class="nav-link">Subnetting</router-link>
          </li>
          <li class="nav-item active">
            <router-link to="/subnetting/asimmetrical" class="nav-link">VLSM</router-link>
          </li>
        </ul>
    </nav>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  data: 
    function () {
      return {
        currentView: 'class-addressing-random'
      };
  }
}
</script>
